<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('dashboard')">
    <vuse-section-definition
      :title="`Dashboard`"
      icon="mdi-view-dashboard"
    ></vuse-section-definition>
    <Announcement />
    <DailyTimeclocks />
    <DailySchedulesGrid class="mt-2"/>
    </div>

    <NoPermission v-else />
    
  </div>
  
</template>

<script>
import { mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import DailyTimeclocks from "src/views/Pages/Dashboard/_DailyTimeclocks";
import DailySchedulesGrid from "src/views/Pages/Dashboard/_DailySchedulesGrid";
import Announcement from "src/views/Pages/Dashboard/_Announcement";
import NoPermission from "components/NoPermission";

export default {
  mixins: [formatterMixin],
  components: {
    DailyTimeclocks,
    DailySchedulesGrid,
    Announcement,
    NoPermission
  },
  data: () => ({}),

  mounted() {},
  computed: {
    ...mapGetters("account", ["hasAccess"]),
  },
};
</script>

